<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">It’s an amazing feat that this is Pete’s third book… It’s not been an easy journey as he’s dyslexic, and has only ever read one book himself.</p>
<br/><p style="text-indent:00em;">After having a serious accident during the first covid lockdown, he has amazed himself and everyone around him with his writing skills. He always had the imagination but could never put it into words – they say miracles do happen, so maybe this is his miracle.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?db923b4e